import { Sparkles } from "lucide-react";
import { CarteSouffleur } from "@/components/scripts/Souffleur";

export const AnalyseAppel = ({ an, onAppliquer }) => (
  <div className="at-soft p-3 space-y-2 text-sm text-left" data-testid="call-ai-analysis">
    <p className="font-bold flex items-center gap-2"><Sparkles size={15} />Résumé de l'IA <span className="text-xs at-muted font-normal">(simulation)</span></p>
    <p className="break-words" data-testid="call-ai-summary">{an.resume}</p>
    <p className="font-semibold" data-testid="call-ai-quality">Qualité : {an.qualite.note}/10</p>
    <ul className="list-disc pl-5 text-xs at-muted">{an.qualite.points.map((p) => <li key={p}>{p}</li>)}</ul>
    {an.souffleur && <CarteSouffleur s={an.souffleur} titre="Objection mal gérée" testId="call-prompter" />}
    {an.statut_nom && (
      <button type="button" onClick={onAppliquer} className="at-btn w-full !justify-start gap-2" style={{ background: "var(--surface)" }} data-testid="call-ai-apply-status">
        <span className="w-3 h-3 at-pill shrink-0" style={{ background: an.couleur }} />Statut proposé : {an.statut_nom}
        {an.rappel_le ? ` · rappel le ${new Date(an.rappel_le).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}` : ""}
      </button>
    )}
    {an.propositions?.length > 0 && <p className="text-xs font-semibold" data-testid="call-ai-proposals">{an.propositions.length} proposition(s) à valider dans « Mon assistant ».</p>}
  </div>
);
